import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MapService } from '@lassi/webapp-shared';
import { LEAFLET_CONTROL_DIRECTIVE } from './leaflet-control.directive';

@Component({
  selector: 'lassi-current-position',
  imports: [MatIconButton, MatIcon],
  template: `
    <button
      aria-label="Zoom map to current location"
      mat-icon-button
      class="map-button"
      color="primary"
      (click)="goToCurrentLocation()"
    >
      <mat-icon>my_location</mat-icon>
    </button>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [LEAFLET_CONTROL_DIRECTIVE],
})
export class CurrentPositionComponent {
  private mapService = inject(MapService);

  goToCurrentLocation() {
    this.mapService.goToCurrentLocation();
  }
}
